import { Component, HostListener, OnInit, ViewChild, EventEmitter, Output  } from '@angular/core';
import { HomeService } from '../_services/home.service';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import {NgbModal,NgbModalConfig,} from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute} from '@angular/router';
import { Router } from '@angular/router';
import { AuthenticationService } from '../_services';


class ModifyPassword{
  oldPassword:string;
  newPassword:string;
  confirmPassword:string;
  userName:string;
  pk: any;
};


@Component({
  selector: 'app-modify-password',
  templateUrl: './modify-password.component.html',
  styleUrls: ['./modify-password.component.scss'],
  providers: [NgbModalConfig, NgbModal]
})


export class ModifyPasswordComponent implements OnInit {
  i18n: any;

  @ViewChild('content') content;

  modifyPwdSuccess: boolean = false;
  successMsg: any;
  modifyPwdIsFailed: boolean;
  failureMsg: any;
  ispopUpShow:boolean =false;
  showModal:boolean=true;
  config: NgbModalConfig;
  password: string;
  innerWidth: number;
  @Output() checkIsPasswordModalOpen = new EventEmitter();
  ValidationPattern: any;
  passwordLength: any;
  errorMessage: any;
  applyPwdPolicyForShp: any;
  
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    console.log("Inner width = ", this.innerWidth);
  }

  constructor(private homeService: HomeService,private modalService: NgbModal,private router: Router,private authService: AuthenticationService) {
    this.i18n = homeService.session.get('i18n');
  }

  

  ngOnInit() {
   
    
  }

  ngAfterViewInit() {
    if(this.authService.getCurrentUser()){ 
    this.openModal();
    }else{
      this.router.navigate([this.router.url.split("/")[1],'login']);
    }
    }
  
  openModal(){
    this.homeService.getPwdPolicies().subscribe(res => {
      if( res.return_body != null || res.return_body !=undefined){
      this.ValidationPattern = res.return_body.pwdComplexity.pwdPattern;
      this.applyPwdPolicyForShp = res.return_body.pwdComplexity.applyForSHP;
      this.passwordLength = res.return_body.pwdComplexity.pwdLength;
      if( this.applyPwdPolicyForShp)
      this.errorMessage = res.return_body.pwdComplexity.errorMessage ;
      else
        this.defaultPwdValidation();
      }
      else
      this.defaultPwdValidation();
    });

    setTimeout(() => {
      this.modalService.open(this.content,{ size: 'lg', backdrop: 'static' });
      
    }, 1000);
    
  }
  defaultPwdValidation(){
    this.passwordLength = 6;
        this.ValidationPattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-zd$@$!%*?&].{6,20}$";
         this.errorMessage=this.i18n['shp.common.newpasswordvalidation'];
  }
  closeModal(){
    this.modalService.dismissAll('Cross click');
    this.checkIsPasswordModalOpen.emit({checkModal: false });
  }

  modifyPassword(f:NgForm){
    const data=new ModifyPassword();
     data.oldPassword=f.value.password;
     data.newPassword=f.value.newpassword;
     data.confirmPassword=f.value.confirmpassword;
     data.userName= this.authService.getCurrentUserName();//localStorage.getItem('username');
     data.pk= this.authService.getCurrentUserPK();//localStorage.getItem('pk');
     this.modifyPwdIsFailed = false;
    
     this.homeService.ModifyPasswordPost(data).subscribe(res => {
      this.modifyPassword = res.return_body;
      console.log(res);
      
        f.resetForm();
        this.modifyPwdSuccess = true;
        this.successMsg=res.error_msg;


    },

        error => {
          this.modifyPwdIsFailed = true;
          const controlError=error;
          this.failureMsg = controlError.error.error_msg;


    });

  }

}
